'use client';

import { useEffect } from 'react';
import { useUserInfoContext } from '../../common/userinfo/UserInfoContext/UserInfoProvider';

const ISLAMIC_THEME_COOKIE = 'islamic_theme';

const IslamicThemeCookieScript = () => {
  const { data } = useUserInfoContext();

  const { isIslamicUser } = data;

  useEffect(() => {
    if (isIslamicUser) {
      document.cookie = `${ISLAMIC_THEME_COOKIE}=1;path=/;max-age=31536000;SameSite=Lax`;

      document.documentElement.setAttribute('data-theme', 'islamic');
    } else {
      document.cookie = `${ISLAMIC_THEME_COOKIE}=;path=/;max-age=0`;

      document.documentElement.removeAttribute('data-theme');
    }
  }, [isIslamicUser]);

  return null;
};

export { IslamicThemeCookieScript, ISLAMIC_THEME_COOKIE };
